import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { Button } from '../../../components/forms/Buttons/Button';
import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
} from '@heroicons/react/24/outline';
import 'react-pdf/dist/esm/Page/AnnotationLayer';

export default function DocumentTab({ document, iin }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [error, setError] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  // Older applications could upload a photo instead of a PDF. The file is
  // stored without an extension, so pdf.js rejecting it is how we tell.
  const isImage = error?.name === 'InvalidPDFException';

  if (document) {
    return (
      <div className=''>
        <div className='px-4 py-4'>
          <h3 className='text-lg font-medium leading-6 text-gray-900'>
            Свидетельство о рождении - ИИН: {iin}
          </h3>
        </div>
        <div className='w-full border-t text-center'>
          {numPages > 1 && `Page ${pageNumber} of ${numPages}`}
          <div className='flex flex-col'>
            {numPages > 1 && (
              <div>
                <Button
                  disabled={pageNumber === 1}
                  onClick={() => {
                    setPageNumber((v) => (v = v - 1));
                  }}
                  Icon={ArrowLeftCircleIcon}
                ></Button>
                <Button
                  disabled={pageNumber === numPages}
                  onClick={() => {
                    setPageNumber((v) => (v = v + 1));
                  }}
                  Icon={ArrowRightCircleIcon}
                ></Button>
              </div>
            )}
            {isImage ? (
              <img src={document} alt='doc' className='mx-auto' />
            ) : (
              <Document
                file={document}
                onLoadSuccess={onDocumentLoadSuccess}
                onLoadError={(e) => {
                  setError(e);
                  console.error('error', e);
                }}
                className='flex justify-center'
              >
                <Page
                  className='w-fit border-2 border-black-landing'
                  pageNumber={pageNumber}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                  height={window.innerWidth > 768 ? 1000 : 500}
                />
              </Document>
            )}
            {error && !isImage && <>
            <div className='text-error'>Ошибка при загрузке документа</div>
            {/* <div className='text-error'>{error?.message} {error?.details}</div> */}
            <div className='text-error flex flex-row justify-center'>
              <pre className='text-left'>{JSON.stringify(error, null, 1)}</pre></div>
            <Button onClick={() => window.open(document, '_blank')} text='Скачать документ' />
            </>
  }
          </div>
        </div>
      </div>
    );
  }
  return <div>no docs</div>;
}
